import React, { useEffect, useState, useRef } from 'react';
import { Searchbar, IconContainer, SearchbarContent } from '../../Inputs/Input';
import { Search } from 'react-ionicons';
import { useDispatch, useSelector } from 'react-redux';
import {
  filterByName,
  setIsSearching,
  filterFavoritesByName,
  resetList,
  getStations,
  setProvince,
  filterByNameWithFilterState,
} from '../../../store/features/stationSlice';
import { useLocation } from 'react-router-dom';
import { setIsLoadingTo } from '../../../store/features/adminSlice';
import { HttpListClient } from '../../../utils/HttpClient';
import Swal from 'sweetalert2';

/**
 * @component
 * displays the navbar searchbar.
 * @example <SearchbarContainer />
 * @returns {void}
 */
const SearchbarContainer = ({ inputRef, moveSearcbar = false }) => {
  const dispatch = useDispatch();
  let location = useLocation();
  const [currentLocation, setCurrentLocation] = useState('');
  const [showSearchbar, setShowSearchbar] = useState(true);

  const { isFiltering, searchByState } = useSelector((state) => state.stations);

  const getStationsFromApi = async () => {
    dispatch(setIsLoadingTo(true));
    let res;
    try {
      let { data } = await HttpListClient.get('/getStations');

      res = JSON.parse(atob(data)) ?? [];
      await dispatch(getStations(res));
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: 'Parece haber un problema con la conexion por favor intente mas tarde.',
        icon: 'warning',
        iconColor: '#FFD732',
        confirmButtonColor: '#003876',
      });
      await dispatch(getStations([]));
    }
    dispatch(setIsLoadingTo(false));
  };

  useEffect(() => {
    let currentPathName = window.location.pathname.split('/')[1];
    setCurrentLocation(currentPathName);
    inputRef.current.value = '';
    dispatch(setIsSearching(false));

    currentPathName.includes('agregar') ||
    currentPathName.includes('editar') ||
    currentPathName.includes('manual')
      ? setShowSearchbar(false)
      : setShowSearchbar(true);
  }, [dispatch, location]);

  useEffect(() => {
    inputRef.current.value = '';
    dispatch(setIsSearching(false));
  }, [searchByState]);

  /**
   * @param {HTMLInputElement} event
   *  mutates the global is searching and mutates the filtered list depending on which URL is current.
   * @returns {void}
   */
  const updateSearchList = (event) => {
    let { value } = event.target;
    if (!isFiltering) {
      if (value.length) {
        currentLocation.includes('fav')
          ? dispatch(filterFavoritesByName(value))
          : dispatch(filterByName(value));
        dispatch(setIsSearching(true));
      } else {
        setImmediate(async () => await getStationsFromApi());
        dispatch(resetList());
        dispatch(setIsSearching(false));
      }
    } else {
      dispatch(setIsSearching(true));
      dispatch(filterByNameWithFilterState(value));
      if (value.trim() === '') {
        dispatch(setIsSearching(true));
      }
    }
  };

  return (
    <SearchbarContent
      style={{
        display: showSearchbar ? 'flex' : 'none',
        marginRight: moveSearcbar ? '200px' : '',
      }}>
      <IconContainer>
        <div
          style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '4px',
          }}>
          <Search color={'#fff'} height="20px" width="20px" />
        </div>
      </IconContainer>
      <Searchbar
        ref={inputRef}
        placeholder="Buscar"
        onKeyUp={(e) => updateSearchList(e)}
      />
    </SearchbarContent>
  );
};

export default SearchbarContainer;
